const params = { locations: 'location', categories: 'category' };

const getRoot = () => document.querySelector('[data-drv-prac]');

const getFilters = () => [...document.querySelectorAll('[data-drv-prac-filter]')];

const syncUrl = () => {
  const url = new URL(window.location.href);
  getFilters().forEach((select) => {
    const name = params[select.dataset.drvPracFilter];
    if (select.value) url.searchParams.set(name, select.value);
    else url.searchParams.delete(name);
  });
  window.history.replaceState(window.history.state, '', url);
};

const render = (root, announce) => {
  const active = getFilters()
    .filter((select) => select.value)
    .map((select) => ({ field: select.dataset.drvPracFilter, needle: `|${select.value}|` }));
  const items = [...root.querySelectorAll('.drv-prac__item')];
  let matches = 0;
  items.forEach((item) => {
    const match = active.every(({ field, needle }) => (item.dataset[field] || '').includes(needle));
    item.hidden = !match;
    if (match) matches += 1;
  });
  const empty = root.querySelector('[data-drv-prac-empty]');
  if (empty) empty.hidden = matches > 0;
  const status = root.querySelector('[data-drv-prac-status]');
  if (announce && status) {
    status.textContent = (root.dataset.countText || '').replace('[count]', matches).replace('[total]', items.length);
  }
};

document.addEventListener('change', (event) => {
  if (!event.target.closest('[data-drv-prac-filter]')) return;
  const root = getRoot();
  if (!root) return;
  render(root, true);
  syncUrl();
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-drv-prac-clear]')) return;
  const root = getRoot();
  if (!root) return;
  const filters = getFilters();
  filters.forEach((select) => {
    select.value = '';
  });
  render(root, true);
  syncUrl();
  filters[0]?.focus();
});

const init = () => {
  const root = getRoot();
  if (!root) return;
  const search = new URLSearchParams(window.location.search);
  getFilters().forEach((select) => {
    const value = (search.get(params[select.dataset.drvPracFilter]) || '').trim().toLowerCase();
    if (value && [...select.options].some((option) => option.value === value)) select.value = value;
  });
  render(root, false);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
